import { loadJSView } from './loadView';

// JS Views
const customerRegistration = loadJSView('front_end/customerRegistration');
const supplierRegistration = loadJSView('front_end/supplierRegistration');
const invoicePayment = loadJSView('front_end/invoicePayment');
const newOrderReview = loadJSView('front_end/newOrderReview');
const emailLinkCaptcha = loadJSView('front_end/emailLinkCaptcha');

const frontEndViews = {
  customerRegistration,
  supplierRegistration,
  invoicePayment,
  newOrderReview,
  emailLinkCaptcha,
};

export default frontEndViews;
